module.exports = __webpack_public_path__ + "media/images/bg/shapes/hex-big-green-42049b6ce942a599fb41d6f402c3a109.svg";